<img [src]="img" alt="avatar" class="user-photo" />
<div class="user-data">
  <strong class="user-name">{{ userData.displayName }}</strong>
  <span class="user-email">{{ userData.email }}</span>
</div>
